<form [formGroup]="skjema" (ngSubmit)="lagre()" novalidate>
  <mat-toolbar color="primary">
    <span>{{ "Registrer ny aksjonær" | translate }}</span>
    <button mat-icon-button mat-dialog-close aria-label="Lukk dialog">
      <mat-icon fontSet="ion-ios-close-empty" class="mat-icon--ionic-ikon"/>
    </button>
  </mat-toolbar>

  <mat-dialog-content #skjemaKontainer>
    <p>{{ "Registrer ny aksjonær i {tittel} i {organisasjonsnavn}" | translate: {tittel: gruppe()?.tittel, organisasjonsnavn: gruppe()?.organisasjonsnavn } }}</p>
    <aksjeeier-rediger [skjema]="skjema"/>
  </mat-dialog-content>

  <mat-dialog-actions align="center">
    <div class="scrollvarsel" [visDersomIkkeScrolletTilBunn]="skjemaKontainer" klasseNaarSynlig="scrollvarsel-synlig"><span>{{'Scroll ned for å se resten av skjemaet...' | translate}}</span></div>
    <button mat-button mat-dialog-close>{{ "Avbryt" | translate }}</button>
   <!-- {{redigerSkjema.skjema.invalid}}-->
    <button mat-raised-button color="primary" type="submit" cdkFocusInitial [disabled]="skjema.invalid || lagrer()" [visSpinner]="lagrer()">{{ "Registrer" | translate }}</button>
  </mat-dialog-actions>

</form>
